"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.IconSelector = exports.IconSelectorDefaultProps = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var IconSelectorDefaultProps = {
  onClick: function onClick() {},
  classNames: {},
  disabled: false
};
exports.IconSelectorDefaultProps = IconSelectorDefaultProps;

var IconSelector = function IconSelector(props) {
  var children = props.children,
      classNames = props.classNames,
      onClick = props.onClick,
      disabled = props.disabled;

  var _useState = (0, _react.useState)(function () {
    // First time through? find if anything is already selected.
    var ret;

    _react.default.Children.forEach(children, function (child, index) {
      if (child.props.selected) {
        ret = index;
      }
    });

    return ret;
  }),
      _useState2 = _slicedToArray(_useState, 2),
      currentlySelected = _useState2[0],
      setCurrentlySelected = _useState2[1];

  var iconSelectorClassName = (0, _classnames.default)('iconselector-component', classNames); // Wrap the children in a supporter div to handle the look/feel

  var renderWrappedChildren = _react.default.Children.map(children, function (child, index) {
    var childDisabled = disabled || child.props.disabled; // function to handle the element being clicked.

    var wrappedOnClick = function wrappedOnClick(event) {
      event.stopPropagation();
      event.preventDefault();

      if (!childDisabled) {
        var newCurrentlySelected = currentlySelected === index ? undefined : index;
        var newCurrentValue = currentlySelected === index ? undefined : child.props.value;
        setCurrentlySelected(newCurrentlySelected);

        if (child.props.onClick) {
          child.props.onClick(event, index, typeof newCurrentlySelected !== 'undefined', newCurrentValue);
        }

        if (onClick) {
          onClick(event, index, typeof newCurrentlySelected !== 'undefined', newCurrentValue);
        }
      }
    };

    var childwrapperClassNames = (0, _classnames.default)({
      'iconselector-component__childwrapper': true,
      'iconselector-component__childwrapper--selected': index === currentlySelected,
      'iconselector-component__childwrapper--disabled': childDisabled
    });

    var newChild = _react.default.cloneElement(child, {
      // Add icon specific settings to get the icons looking good in the select button
      size: '2x',
      disabled: childDisabled,
      onClick: wrappedOnClick
    });

    var addItemParam = childDisabled ? {
      tabIndex: -1
    } : {
      onClick: wrappedOnClick
    };
    return /*#__PURE__*/_react.default.createElement("button", _extends({
      key: index,
      className: childwrapperClassNames
    }, addItemParam), newChild);
  });

  return /*#__PURE__*/_react.default.createElement("div", {
    className: iconSelectorClassName,
    tabIndex: -1
  }, renderWrappedChildren);
};

exports.IconSelector = IconSelector;
IconSelector.propTypes = {
  onClick: _propTypes.default.func.isRequired,
  classNames: _propTypes.default.any.isRequired,
  disabled: _propTypes.default.bool.isRequired,
  children: _propTypes.default.node
};
IconSelector.defaultProps = IconSelectorDefaultProps;
var _default = IconSelector;
exports.default = _default;